module.exports = __webpack_public_path__ + "img/cat3.2f4ecee9.svg";